































import SfArticleCard from "~/themes/fiskarsMoominDefault/components/components/molecules/SfArticleCard/SfArticleCard.vue";
import { defineComponent } from "@nuxtjs/composition-api";

export default defineComponent({
  name: "ArticleSlider",
  components: {
    SfArticleCard,
    SfCarousel: () => import("~/themes/fiskarsMoominDefault/components/components/organisms/SfCarousel/SfCarousel.vue"),
},
  methods: {
    getCardBackgroundColor(cardObj) {
      return cardObj?.background?.background?.selectionValues[0]?.key;
    }
  },
  computed: {
    items: function () {
      if(!this.articleItems || this.articleItems.items.length === 0) return [];
      if(this.articleItems.items.length !== 2) return this.articleItems.items;
      return [...this.articleItems.items].reverse();
    }
  },
  props: {
    articleItems: {
      type: Object,
      default: () => ({ items: [] }),
    },
    carouselSettings: {
        type: Object,
        default: () => ({
          type: "carousel",
          gap: "50%",
          startAt: 1,
          dots: true,
          slidePerPage: true,
          direction: "ltr",
          rewind: true,
          throttle: 100,
          perView: 2,
          breakpoints: {
            1023: {
              perView: 1,
              autoplay: 0,
            },
            767: {
              perView: 1,
              autoplay: 0,
            },
            510: {
              perView: 1,
              autoplay: 0,
            },
          },
        })
      },
    title: {
        type: String,
        default: "",
    },
    description: {
        type: String,
        default: "",
    },
    sectionLinkText: {
        type: String,
        default: "",
    },
    link: {
        type: [Object, String],
        default: "",
    },
    perView: {
      type: Number,
      default: 2
    },
  },
});
